import { render, staticRenderFns } from "./TraineeDocuments.vue?vue&type=template&id=28fd18d9&"
import script from "./TraineeDocuments.vue?vue&type=script&lang=js&"
export * from "./TraineeDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports